export interface CalculationResult {
  so_luong: number;
  gia: number;
  thanh_tien: number;
  thue: number;
  tong_tien: number;
}

export function calculateTotals(detailItems: MuaHangRecord[] = [], state: MuaHangRecord): CalculationResult {
  const so_luong = detailItems.reduce((sum, item) => sum + (parseFloat(item.so_luong) || 0), 0);
  const gia = detailItems.reduce((sum, item) => sum + (parseFloat(item.gia) || 0), 0);
  const thanh_tien = detailItems.reduce((sum, item) => sum + (parseFloat(item.tien_nt) || 0), 0);
  const thue = (thanh_tien * (state.taxModel?.thue_suat || 0)) / 100 || 0;
  const tong_tien = thanh_tien + thue;

  return {
    so_luong,
    gia,
    thanh_tien,
    thue,
    tong_tien
  };
}

export const handleUpdateRowFields = (row: MuaHangRecord, field: string, newValue: MuaHangRecord) => {
  if (field === 'so_luong' || field === 'gia_nt') {
    const so_luong = field === 'so_luong' ? newValue : row.so_luong;
    const gia_nt = field === 'gia_nt' ? newValue : row.gia_nt;
    const tien_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);

    return {
      tien_nt
    };
  }
  return {};
};
